import {
  createStyleMixin,
  draggableMixin,
  componentNameValidationMixin,
  activeableMixin,
} from '@descope-ui/common/components-mixins';
import { compose } from '@descope-ui/common/utils';
import { getComponentName } from '@descope-ui/common/components-helpers';
import { injectStyle } from '@descope-ui/common/components-helpers';
import { createBaseClass } from '@descope-ui/common/base-classes';

export const componentName = getComponentName('list-item');

const customMixin = (superclass) =>
  class ListItemMixinClass extends superclass {
    constructor() {
      super();

      this.attachShadow({ mode: 'open' }).innerHTML = `
      <slot></slot>
    `;

      injectStyle(
        `
      slot {
          width: 100%;
          display: flex;
          overflow: hidden;
          box-sizing: border-box;
      }
      :host {
        display: block;
      }
        `,
        this,
      );
    }
  };

export const ListItemClass = compose(
  createStyleMixin({
    mappings: {
      verticalPadding: [
        { property: 'padding-top' },
        { property: 'padding-bottom' },
      ],
      horizontalPadding: [
        { property: 'padding-left' },
        { property: 'padding-right' },
      ],
      backgroundColor: {},
      borderColor: {},
      borderStyle: {},
      borderWidth: {},
      borderRadius: {},
      outline: {},
      cursor: {},
      gap: {},
      maxWidth: { selector: () => ':host' },
      alignItems: {},
      flexDirection: {},
      transition: {},
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
  customMixin,
  activeableMixin,
)(createBaseClass({ componentName, baseSelector: 'slot' }));
